import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

export function RichText({ json }) {
  return documentToReactComponents(json, {})
}
